export default __webpack_public_path__ + "static/media/icon-role-Product-Owner.c769e6ca.svg";